// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603251533/js/" + chunkId + "." + {"44":"2e395152","225":"1bd35f41","481":"747439c8","486":"d73b8771","770":"f66c2517"}[chunkId] + ".0.7837949414892145.chunk.js";
};